/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import { Space } from '@coze-arch/coze-design';

import {
  WorkspaceListItem,
  type IWorkspaceListItem,
} from './workspace-list-item';

interface WorkspaceListProps {
  menus?: Array<IWorkspaceListItem>;
  menuGroups?: Array<IWorkspaceMenuGroup>;
  currentSubMenu?: string;
}

export interface IWorkspaceMenuGroup {
  key: string;
  title: () => string;
  menus: Array<IWorkspaceListItem>;
}

const renderMenus = (
  menus: Array<IWorkspaceListItem>,
  currentSubMenu?: string,
) => (
  <Space vertical spacing={4} className="w-full">
    {menus.map((item, index) => (
      <WorkspaceListItem
        {...item}
        key={index}
        currentSubMenu={currentSubMenu}
      />
    ))}
  </Space>
);

export const WorkspaceList: FC<WorkspaceListProps> = ({
  menus = [],
  menuGroups,
  currentSubMenu,
}: WorkspaceListProps) => (
  <div className="w-full mt-[16px]">
    {menuGroups?.length ? (
      <Space vertical spacing={16} className="w-full">
        {menuGroups.map(group => (
          <div className="w-full" key={group.key}>
            <div className="px-[8px] text-[12px] leading-[16px] font-[500] coz-fg-secondary">
              {group.title()}
            </div>
            <div className="mt-[4px]">
              {renderMenus(group.menus, currentSubMenu)}
            </div>
          </div>
        ))}
      </Space>
    ) : (
      renderMenus(menus, currentSubMenu)
    )}
  </div>
);
